<template>
  <div class="flex-panel full-settings-panel ">
    <div class="settings-header">
      <div class="header-text-image">
        <dr-svg image="SETTINGS-LAYOUT" color="var(--accentColor)" size="16"></dr-svg>
      </div>
      <div class="header-text">{{ $t('menuLayout.settingsLayout.desktopCustomization') }}</div>
      <i aria-hidden="true" class="v-icon notranslate mdi mdi mdi mdi-close theme--light" @click="onClose" :class="{ 'hidden': inFrame }"></i>
    </div>
    <div class="flex-panel all-widgets">
      <div :class="widgetsActive ? 'block-panel' : 'flex-panel template-container'">
        <div class="flex-panel" style="max-height: 100%;">
          <div class="settings-widgets-header">
            <div class="header-text-image">
              <dr-svg :image="widgetsActive ? 'WIDGETS' : 'TEMPLATES'" color="#212121" size="16"></dr-svg>
            </div>
            <div class="header-text">{{ widgetsActive ? $t('menuLayout.settingsLayout.widgets') : $t('menuLayout.settingsLayout.templates')}}</div>
            <div v-if="widgetsActive" class="toggle-button-container">
              <v-btn icon text tile x-small :disabled="!isCardView" @click="onToggleClick">
                <dr-svg image="SNIPPET-LINES" :color="!isCardView ? 'var(--accentColor)' : '#979797'" size="16"></dr-svg>
              </v-btn>
              <v-btn icon text tile x-small :disabled="isCardView" @click="onToggleClick">
                <dr-svg image="SNIPPET-CARDS" :color="isCardView ? 'var(--accentColor)' : '#979797'" size="16"></dr-svg>
              </v-btn>
            </div>
          </div>
          <div class="widgets-preview" v-if="!widgetsListMode && widgetsActive">
            <div id="help-label-widgets-preview" class="help-label">{{ $t('menuLayout.settingsLayout.addWidgetsToDesktop') }}</div>
          </div>
          <div class="flex-panel widgets-list"  v-if="widgetsListMode && widgetsActive">
            <div id="help-label-widgets-list" class="help-label">{{ $t('menuLayout.settingsLayout.addOrDeletewidget') }}</div>
            <div v-if="!isCardView" class="flex-panel widgets-list-container">
              <v-checkbox :label="item.name" @click="changeWidgetState" v-for="item in widgetsModels" v-bind:key="item.id" :value="item.id" v-model="selectedWidgets" class="widget-check"></v-checkbox>
            </div>
            <div v-else class="flex-panel widgets-list-container" :class="{ 'card-view': isCardView }">
              <div v-for="item in widgetsModels" @click="onSelectWidget(item.id)" v-bind:key="item.id" :class="{ 'widget-container': true, 'active': selectedWidgets.includes(item.id) }">
                <v-btn block text class="widget-iamge-container">
                  <img :src="item.previewImage"/>
                  <v-icon v-if="selectedWidgets.includes(item.id)" color="var(--accentColor) !important">mdi-check-circle</v-icon>
                </v-btn>
                <div class="widget-caption">{{ item.name }}</div>
              </div>
            </div>
          </div>
          <div class="flex-panel template-preview" v-if="!widgetsActive">
            <div class="help-label">{{ $t('menuLayout.settingsLayout.viewPreConfiguredTemplate') }}</div>
            <div class="flex-panel templates-container">
              <div v-for="item in templates" class="template" v-bind:key="item.id">
                <i v-if="isAdmin" aria-hidden="true" class="v-icon notranslate mdi mdi mdi mdi-close theme--light delete-template" @click="onDeleteTemplate(item)"></i>
                <v-btn block text class="image-container" :class="{ 'active': item.active }" v-model="templates" @click="onTemplateClick(item)">
                  <img :src="item.imageb64"/>
                </v-btn>
                <div class="template-caption">{{ item.caption }}</div>
              </div>
            </div>
          </div>
          <div class="flex-panel save-template" v-if="isAdmin && !widgetsActive">
            <v-dialog v-model="showTemplateNameDilog" persistent max-width="350px">
              <template v-slot:activator="{ on, attrs }">
                <v-btn block plain text v-bind="attrs" v-on="on">
                  <div class="text">{{ $t('menuLayout.settingsLayout.saveCurrentDesktopToTemplate') }}</div>
                </v-btn>
              </template>
              <v-card>
                <v-card-title>
                  {{ $t('menuLayout.settingsLayout.enterTemplateName') }}
                </v-card-title>
                <v-card-text>
                  <v-text-field v-model="templateName" :label="$t('menuLayout.settingsLayout.templateName')" required/>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="blue darken-1" text @click="showTemplateNameDilog = false">
                    {{ $t('menuLayout.settingsLayout.cancel') }}
                  </v-btn>
                  <v-btn color="blue darken-1" text @click="onSaveTemplateClick">
                    {{ $t('menuLayout.settingsLayout.ok') }}
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </div>
        </div>
      </div>
    </div>
    <div class="flex-panel settings-users" v-if="isAdmin">
      <v-select class="combo" :value="this.currentSettingsType" :outlined="false" :items="settingsTypeItems" @change="onSettingsTypeChange"></v-select>
      <v-select class="combo" :value="this.currentComboValue" :items="currentTypeValues" :item-text="item => item.name + ' (' + item.id + ')'" :item-value="item => item.id" @change="onUserGroupChange"></v-select>
    </div>
    <div class="flex-panel settings-buttons" >
      <div class="switch">
        <v-btn text block @click="onSwitchClick" color="var(--md-pallete-on-500)">
          <dr-svg :image="!widgetsActive ? 'WIDGETS' : 'TEMPLATES'" color="var(--md-pallete-on-500)" size="16"></dr-svg>
          {{ !widgetsActive ? $t('menuLayout.settingsLayout.widgets') : $t('menuLayout.settingsLayout.templates') }}
        </v-btn>
      </div>
      <div v-if="widgetsActive" class="history-container">
        <div class="history-separator"/>
        <v-btn class="undo" :disabled="historyProps.undoDisable" text small block @click="onUndoButtonClick" color="var(--md-pallete-on-500)">
          <dr-svg image="UNDO-LAYOUT" color="var(--md-pallete-on-500)" size="16"></dr-svg>
        </v-btn>
        <v-btn class="redo" :disabled="historyProps.redoDisable" text small block @click="onRedoButtonClick" color="var(--md-pallete-on-500)">
          <dr-svg image="REDO-LAYOUT" color="var(--md-pallete-on-500)" size="16"></dr-svg>
        </v-btn>
        <div class="history-separator"/>
      </div>
      <div v-else class="separator"/>
      <div class="save">
        <v-btn text block @click="onSaveButtonClick" color="var(--md-pallete-on-500)">
          <dr-svg image="SAVE-LAYOUT" color="var(--md-pallete-on-500)" size="16"></dr-svg>
          {{ $t('menuLayout.settingsLayout.save') }}
        </v-btn>
      </div>
    </div>
  </div>
</template>


<script>

let settingsTypeEnum = {
  User: 0,
  Group: 1
}
import { MainMenuApi as api } from '../../api/api.js'
import { getControlIdFromItem } from '../../tools/convertItemData'
import drSvg from '@/mainMenuSrc/components/customWidgets/dr-svg'
import html2canvas from 'html2canvas'
export default {
  name: 'dr-settings-layout-component',
  props: [ 'mainLayout', 'historyProps' ],
  components: {
    drSvg
  },
  data: function() {
    return {
      isAdmin: false,
      usersList: {
        id: '',
        name: '',
        selected: false
      },  
      groupsList: {
        id: '',
        name: ''
      },
      settingsTypeItems: [
        {value: settingsTypeEnum.User, text: this.$t('menuLayout.settingsLayout.user')},
        {value: settingsTypeEnum.Group, text: this.$t('menuLayout.settingsLayout.group')}
      ],
      currentSettingsType: settingsTypeEnum.User,
      widgetsListMode: true,
      widgets: [...this.$store.state.appRunner.model.Modules.DefaultModuleImpl.Snippets, ...this.$store.state.appRunner.model.UserModel.Modules.DefaultModuleImpl.Snippets],
      selectedWidgets: [],
      currentComboValue: '',
      ops: {
        bar: {
          background: '#aaa',
          size: '10px'
        },
        rail: {
          size: '10px'
        }
      },
      oldMainLayout: [],
      savedMainLayout: [],
      widgetsActive: true,
      templates: [],
      showTemplateNameDilog: false,
      templateName: '',
      isCardView: true
    }
  },
  
  computed: {
    widgetsModels() {
      let widgetsModels = []
      for (let i = 0; i < this.widgets.length; i++) {
        let currentWidget =  this.widgets[i]
        widgetsModels.push( { id: currentWidget.$ID, name: currentWidget.Name, previewImage: currentWidget.AdditionalProperties?.PreviewImage?.default } )
      }
      return widgetsModels
    },
    inFrame() {
      return window.self !== window.top
    },
    currentTypeValues() {
      return this.currentSettingsType == settingsTypeEnum.User ? this.usersList : this.groupsList
    }
  },

  async created() {
    let value = localStorage.getItem('isCardView')
    this.isCardView = value != null ? value === 'true' ? true : false : this.isCardView
    this.updateSelected()
    let data = await api.getUsersAndGroupsData()
    if (!data && !data.data.iTEnterpriseMenuSettingsQuery) {
      return
    }
    if (data.data.iTEnterpriseMenuSettingsQuery.usersList) {
      this.usersList = data.data.iTEnterpriseMenuSettingsQuery.usersList
      let currentUser = this.usersList.find(t => t.selected)
      if (currentUser) {
        this.currentComboValue = currentUser.id
      }
    }
    if (data.data.iTEnterpriseMenuSettingsQuery.groupsList) {
      this.groupsList = data.data.iTEnterpriseMenuSettingsQuery.groupsList
    }
    if (data.data.iTEnterpriseMenuSettingsQuery.isAdmin) {
      this.isAdmin = data.data.iTEnterpriseMenuSettingsQuery.isAdmin
    }
    this.refreshSelected()
  },
  
  methods: {
    onSettingsTypeChange: function (e) {
      this.currentSettingsType = e
    },

    onUserGroupChange: function (e) {
      this.currentComboValue = e
    },
    
    onClose: function () {
      let page = localStorage.getItem('startFromLauncher') ? 'ListViewPage' : 'HomePage'
      localStorage.setItem('startFromLauncher', '')
      this.$routerCore.router.push({ name: page })
    },
    
    changeWidgetState: function () {
      this.$emit('updatePanels', this.selectedWidgets)
    },
    
    updateSelected() {
      this.selectedWidgets = []
      for (let i = 0; i < this.mainLayout.length; i++) {
        let layout = this.mainLayout[i]
        let controlId = getControlIdFromItem(layout)
        this.selectedWidgets.push(controlId)
      }
    },

    async onSaveButtonClick() {
      let isUserSettings = this.currentSettingsType == settingsTypeEnum.User
      let id = this.currentComboValue
      this.savedMainLayout = [...this.mainLayout]
      this.updateSelected()
      await api.saveMainMenuLayoutSettings(isUserSettings, id, JSON.stringify(this.mainLayout))
    },

    onUndoButtonClick() {
      this.$emit('undoHistory')
    },

    onRedoButtonClick() {
      this.$emit('redoHistory')
    },

    refreshSelected() {
      if (this.mainLayout && this.mainLayout.length != this.oldMainLayout.length && !this.historyProps.templatesActive) {
        this.oldMainLayout = this.mainLayout
        this.updateSelected()
      }
      let that = this
      clearTimeout(this.timer)
      this.timer = setTimeout(function() {
        that.refreshSelected()
      }, 50)
    },

    onTemplateClick(item) {
      this.templates.forEach(template => {
        template.active = false
      })
      item.active = true
      this.mainLayout.splice(0, this.mainLayout.length)
      this.mainLayout.push(...item.templates)
    },

    async onSwitchClick() {
      this.widgetsActive = !this.widgetsActive
      if (this.widgetsActive) {
        this.mainLayout.splice(0, this.mainLayout.length)
        this.mainLayout.push(...this.savedMainLayout)
      } else {
        if (!this.templates.length) {
          let templateData = await api.getMenuTemplatesDescription()
          let templates = templateData.data.iTEnterpriseMenuSettingsQuery.templatesDescription
          templates.forEach(template => {
            template.active = false
          })
          this.templates = templates
        }
        this.savedMainLayout = [...this.mainLayout]
        this.templates.forEach(template => {
          template.active = false
        })
      }
      this.historyProps.templatesActive = !this.widgetsActive
    },

    async onSaveTemplateClick() {
      if (this.templateName) {
        this.showTemplateNameDilog = false
        let layoutPlace = document.getElementById('defaultLayout')
        layoutPlace.classList.add('fill-snippets')
        await html2canvas(layoutPlace).then((canvas) => {
          let printScreen = canvas.toDataURL('image/png')
          layoutPlace.classList.remove('fill-snippets')
          this.templates.forEach(template => {
            template.active = false
          })
          this.templates.push({
            id: this.templates[this.templates.length - 1].id + 1,
            active: true,
            caption: this.templateName,
            imageb64: printScreen,
            templates: [...this.mainLayout]
          })
          api.menuSaveTemplateDescription(this.templateName, printScreen, JSON.stringify(this.mainLayout))
          this.templateName = ''
        })
      }
    },

    async onDeleteTemplate(item) {
      this.templates = this.templates.filter(template => { return template.id != item.id })
      await api.menuDeleteTemplateDescription(item.id)
    },

    onToggleClick() {
      this.isCardView = !this.isCardView
      localStorage.setItem('isCardView', this.isCardView)
    },

    onSelectWidget(id) {
      if (this.selectedWidgets.includes(id)) {
        this.selectedWidgets = this.selectedWidgets.filter(i => i != id)
      } else {
        this.selectedWidgets.push(id)
      }
      this.$emit('updatePanels', this.selectedWidgets)
    }
  }
}
</script>

<style>

.flex-panel .settings-header {
  display: flex;
  flex-direction: row;
  flex-grow: 0;
}

.flex-panel .header-text {
  display: flex;
  flex: 1;
}

.flex-panel {
  display: flex;
  flex-direction: column;
}

.flex-panel.full-settings-panel {
  background-color: white;
  border-radius: 4px;
  right: 0;
  min-width: 344px;
  width: 344px;
  margin: var(--frame-padding) var(--frame-padding) var(--frame-padding) 0;
  height: calc(100% - 2*var(--frame-padding));
  justify-content: space-between;
}

.flex-panel.settings-users, .flex-panel.settings-buttons {
  margin: 0px 14px;
}

.flex-panel.settings-buttons {
  flex-direction: row;
  background: var(--md-pallete-500);
  border-radius: 8px;
  align-items: center;
  height: 40px;
  min-height: 40px;
  margin-bottom: 8px;
}

.flex-panel.settings-buttons .history-container {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 90px;
}

.flex-panel.settings-buttons .history-container button {
  min-width: 0px !important;
  padding: 0px;
  height: 100%;
  width: 34px;
  box-sizing: unset;
}

.flex-panel.settings-buttons .history-container .undo.v-btn--disabled svg,
.flex-panel.settings-buttons .history-container .redo.v-btn--disabled svg {
  opacity: 0.5
}

.flex-panel.settings-buttons .history-container .history-separator, .flex-panel.settings-buttons .separator {
  height: 24px;
  border-right: 1px solid #FFFFFF20;
}

.flex-panel.settings-buttons .save,
.flex-panel.settings-buttons .switch {
  display: flex;
  justify-content: center;
  width: 100%;
  height: 100%;
}

.flex-panel.settings-buttons .save .v-btn__content,
.flex-panel.settings-buttons .switch .v-btn__content {
  font-weight: 400;
  font-size: 12px;
  line-height: 14px;
  display: flex;
  align-items: center;
  text-transform: none;
  letter-spacing: normal;
}

.flex-panel.settings-buttons .save button,
.flex-panel.settings-buttons .switch button {
  padding: 0px;
  height: 100%;
}

.flex-panel.settings-buttons .save .v-btn__content svg,
.flex-panel.settings-buttons .switch .v-btn__content svg {
  margin-right: 8px;
}

.settings-users .combo.v-text-field .v-input__control .v-input__slot {
  border: 1px solid;
  border-color: #C4C4C4;
  border-radius: 8px;
}

.settings-users .combo.v-text-field .v-text-field__details {
  display: none;
}
.settings-users .combo.v-text-field {
  padding-top: 0;
  margin-top: 0;
}

.flex-panel .settings-header .v-icon.hidden {
  display: none;
}

.settings-widgets-header {
  display: flex;
  padding-bottom: 8px;
}


.flex-panel.all-widgets {
  flex-shrink: 1;
  flex-grow: 1;
  overflow: hidden;
}

.settings-header.widgets {
  flex:1;
}

.block-panel {
  display: block;
  max-height: 100%;
}

.template-container {
  height: 100%;
}

.template-container .flex-panel:first-child {
  height: 100%;
}

.widgets-list {
  max-height: 100%;
  overflow: hidden;
}

.widgets-list-container {
  flex-shrink: 1;
  overflow: auto;
  max-height: 100%;
}

.header-text {
  font-size: 14px;
}

.settings-header .header-text {
  color: var(--accentColor);
  line-height: 16px;
  font-weight: 400;
  font-size: 14px;
  align-items: center;
}

.settings-widgets-header .header-text {
  font-weight: 400;
  font-size: 14px;
  line-height: 16px;
  display: flex;
  align-items: center;
  color: #212121;
}

.all-widgets .help-label {
  color: #5e6a6fe3;
  font-size: 13px;
  line-height: 14px;
}

.all-widgets .flex-panel.widgets-list-container {
  padding: 5px 0;
}

.flex-panel.settings-users .v-select__selection, .flex-panel.widgets-list .v-input .v-label {
  font-size: 12px;
}
.all-widgets, .settings-header {
  padding: 8px 14px;
}

.settings-header {
  padding-bottom: 4px;
}

.all-widgets {
  padding-top: 4px;
}

.widgets-list-container::-webkit-scrollbar,
.templates-container::-webkit-scrollbar
{
  width: 10px;
	background-color: transparent;
}
.widgets-list-container::-webkit-scrollbar-thumb,
.templates-container::-webkit-scrollbar-thumb
{
	border-radius: 10px;
	background-color: #aaa;
}
.widgets-list-container::-webkit-scrollbar:hover,
.templates-container::-webkit-scrollbar:hover
{
	background-color: #F5F5F5;
}

.settings-header .header-text-image {
  align-items: center;
  padding-right: 14px;
  display: flex;
}

.settings-header .v-icon {
  color: #21212180;
  cursor: pointer;
  border-radius: 50%;
}

.settings-header .v-icon:hover {
  background: #eee;
}

.settings-widgets-header .header-text-image svg {
  margin-right: 14px;
}

.widget-check {
  margin: 0px;
  padding: 9px 0px;
}

.widget-check .v-messages {
  display: none;
}

.widget-check .v-input__slot {
  margin: 0px;
  height: 14px;
}

.widget-check .v-label {
  line-height: 14px;
  color: #212121;
}

.widget-check .v-input__control .v-input__slot .v-input--selection-controls__input i {
  color: var(--md-pallete-500) !important;
  font-size: 14px;
}

.widget-check .v-input__control .v-input__slot .v-input--selection-controls__input .mdi-checkbox-marked::before {
  content: "\F0C52";
}

.widget-check .v-input__control .v-input__slot .v-input--selection-controls__input .v-application .primary--text {
  color: unset;
}

.widget-check .v-input--selection-controls__input {
  margin-right: 13px;
  width: 14px;
  height: 14px;
  margin-left: 5px;
}

.widget-check .v-input--selection-controls__ripple {
  margin: 13px 9px;
  height: 20px;
  width: 20px;
}

.settings-users .combo.v-text-field .v-input__control .v-input__slot:after, .settings-users .combo.v-text-field .v-input__control .v-input__slot:before {
  display: none !important;
}

.settings-users  .v-select__selection--comma {
  text-indent: 16px;
}

.template-preview {
  overflow: hidden;
  height: 100%;
}

.template-preview .templates-container {
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
  flex-shrink: 1;
  overflow: auto;
  max-height: 100%;
  margin-top: 8px;
}

.template-preview .templates-container .template {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 150px;
  position: relative;
}

.template-preview .templates-container .template .delete-template {
  position: absolute;
  z-index: 1;
  right: 4px;
  top: 4px;
  cursor: pointer;
  display: none;
  border-radius: 50%;
}

.template-preview .templates-container .template .delete-template:hover {
  background: #aeaeae;
}

.template-preview .templates-container .template:hover .delete-template {
  display: flex;
}

.template-preview .templates-container .template .image-container {
  width: 150px;
  height: 120px;
  max-height: 120px;
  max-width: 150px;
  background: #FFFFFF;
  border: 1px solid #C4C4C4;
  display: flex;
  overflow: hidden;
  padding: 0px;
}

.template-preview .templates-container .template .image-container.active {
  border: 2px solid #5F7D8A;
}

.template-preview .templates-container .template .image-container .v-btn__content {
  width: 100%;
  height: 100%;
}

.template-preview .templates-container .template .image-container img {
  width: 100%;
  height: 100%;
  padding: 1px;
}

.template-preview .templates-container .template-caption {
  font-size: 12px;
  line-height: 12px;
  text-align: center;
  padding: 4px 0px;
}

.save-template {
  margin-top: 8px;
}

.save-template button.v-btn.v-size--default {
  height: 14px;
  padding: 0px;
}

.save-template button .text {
  text-decoration-line: underline;
  text-transform: none;
  font-size: 12px;
  font-weight: 400;
  letter-spacing: normal;
}

.toggle-button-container button {
  padding: 2px;
  box-sizing: unset;
}

.widgets-list-container.card-view {
  flex-wrap: wrap;
  flex-direction: row;
  justify-content: space-between;
}

.widgets-list-container .widget-container {
  display: flex;
  flex-direction: column;
  width: 145px;
}

.widgets-list-container .widget-container.active button {
  border: 2px solid var(--accentColor);
}

.widgets-list-container .widget-container.active button i {
  position: absolute;
  padding: 70px 4px 4px 115px;
  background: #aeaeae60;
}

.widgets-list-container .widget-container button {
  border: 1px solid #aeaeae;
  border-radius: 8px;
  overflow: hidden;
}

.widgets-list-container .widget-container button .v-btn__content {
  width: 100%;
  height: 100%;
}

.widgets-list-container .widget-container .widget-iamge-container {
  padding: 0px;
  height: 100px;
  max-height: 100px;
  background: #C4C4C4;
}

.widgets-list-container .widget-container .widget-iamge-container img {
  height: 100%;
  width: 100%;
  display: flex;
}

.widgets-list-container .widget-container .widget-caption {
  font-weight: 400;
  font-size: 12px;
  line-height: 14px;
  color: #212121;
  padding: 8px 0px;
}
</style>